import { useState } from "react";
import { Collapse } from "react-bootstrap";
import { useUsuario } from "../../context/UsuarioContext";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { httpPost } from "../../http/request";
import { useGoogleLogin } from "@react-oauth/google";
import { mostrarAlertaDanger } from "../../functions/alertas";
import { VERSION_APP } from "../../config/configBase";

const Login2 = () => {
  const { setToken, tkApp, setSpinnerLoad } = useUsuario();
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [viewPass, setViewPass] = useState(false);
  const [open, setOpen] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    loginUsuario({ user, pass });
  };

  const loginUsuario = (r) => {
    r["tkApp"] = tkApp;
    console.log(r);
    setSpinnerLoad(true);
    httpPost(r, "/api/v1/login/user").then((d) => {
      console.log(d);
      if (d) {
        setToken(d.token);
      }
      setSpinnerLoad(false);
    });
  };

  const loginGoogle = (r) => {
    r["tkApp"] = tkApp;
    console.log(r);
    httpPost(r, "/api/v1/login/signGoogle").then((d) => {
      console.log(d);
      if (d) {
        setToken(d.token);
      }
    });
  };

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => loginGoogle(codeResponse),
    error_callback: () => {
      mostrarAlertaDanger("ocurrió un error al iniciar con Google");
    },
    ux_mode: "popup",
  });

  return (
    <div className="container-fluid vh-100 d-flex flex-column flex-md-row p-0">
      {/* Sección del logo */}
      <div className="col-md-6 d-none d-md-flex bg-light flex-column justify-content-center align-items-center p-4 text-center">
        <img
          src="https://sigta.uap.edu.bo/static/media/LOGOS_UAP_AZUL.671bdb5a507678839e89.png"
          alt="Universidad Amazónica de Pando"
          className="img-fluid mb-3"
          style={{ maxWidth: "220px" }}
        />
        <h2 className="text-primary fw-bold">Universidad Amazónica de Pando</h2>
        <p className="text-muted mb-0">Cobija - Bolivia</p>
        <p className="text-secondary small mt-1">Sistema Informático de Gestion de Tramites Académicos v.{VERSION_APP}</p>
      </div>

      {/* Sección del formulario */}
      <div className="col-md-6 col-12 d-flex flex-column justify-content-center align-items-center bg-white p-4">
        {/* Logo pequeño para móviles */}
        <div className="d-md-none mb-3 text-center">
          <img
            src="https://sigta.uap.edu.bo/static/media/LOGOS_UAP_AZUL.671bdb5a507678839e89.png"
            alt="UAP"
            style={{ width: "80px" }}
            className="mb-2"
          />
          <h5 className="text-primary fw-bold mb-1">Universidad Amazónica de Pando</h5>
          <p className="text-muted small mb-0">Cobija - Bolivia</p>
          <p className="text-secondary small">v.{VERSION_APP}</p>
        </div>

        <div className="w-100" style={{ maxWidth: "400px" }}>
          <h4 className="mb-4 text-center fw-bold">Inicio de Sesión</h4>

          <div className="d-grid gap-2 mb-3">
            <button className="btn btn-primary btn-block btn-brand-02" onClick={() => setOpen(!open)}>
              Inicia sesión con tu cuenta de
              <br /> <strong>Siringuero</strong> o <strong>Perla Plus</strong>
            </button>
          </div>
          <Collapse in={open}>
            <div id="example-collapse-text" className="px-2">
              <p className="text-muted mb-3">¡Bienvenido! Por favor ingrese su usuario y contraseña para continuar.</p>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="usuario" className="form-label">
                    Usuario
                  </label>
                  <input type="text" className="form-control" placeholder="Ingresa tu usuario" onChange={(e) => setUser(e.target.value)} />
                </div>

                <div className="mb-4">
                  <div className="d-flex justify-content-between mg-b-5">
                    <label className="mg-b-0-f">Contraseña</label>
                  </div>
                  <div className="" style={{ position: "relative" }}>
                    <input
                      type={viewPass ? "text" : "password"}
                      className="form-control"
                      placeholder="Ingresa tu contraseña"
                      onChange={(e) => setPass(e.target.value)}
                    />
                    <div
                      className="d-flex"
                      style={{
                        position: "absolute",
                        top: "0",
                        right: "0",
                        bottom: "0",
                      }}
                    >
                      <span
                        className="tx-15 me-1 text-primary pointer m-auto p-1 pe-2"
                        onClick={() => {
                          setViewPass(!viewPass);
                        }}
                      >
                        {viewPass ? <FaEye /> : <FaEyeSlash />}
                      </span>
                    </div>
                  </div>
                </div>
                <button
                  className="btn btn-primary btn-brand-02 w-100 mb-3"
                  type="submit"
                  /*onClick={() => loginUsuario({ user, pass })}*/
                >
                  Iniciar sesión
                </button>
              </form>
            </div>
          </Collapse>
          <div className="text-center my-3">
            <div className="divider-text mb-3 text-center">o</div>
          </div>

          <button className="btn btn-danger btn-block p-3 w-100" onClick={() => login()}>
            Inicia Sesión con tu cuenta de <strong>Google</strong>
          </button>

          <p className="text-muted text-center small mt-2">Elige esta opción si no tienes acceso al sistema académico.</p>
        </div>
      </div>
    </div>
  );
};

export default Login2;
